export default __webpack_public_path__ + "static/media/AcornOffice_23.fc2ef185.png";